module.exports = "<h1><i class=\"fa fa-info-circle\" aria-hidden=\"true\"></i> How To</h1>\n<div class=\"content\" [innerHTML]=\"howToContent\"></div>\n"